import { FC, useEffect, useMemo, useState } from "react";
import { DashboardDevice } from "../../../../../../models/api/DashboardDevice";
import { CurrentWidgetMeasurementConfig } from "../../../SimpleAppTemplate";
import useCurrentRainfallIndicator from "../hooks/useCurrentRainfallIndicator";
import { getIndicator } from "../../WidgetHelper";

type Props = {
  device: DashboardDevice;
  orgId?: string;
  measurement: CurrentWidgetMeasurementConfig;
};

// TODO: Informative Comment
const CurrentRainfallIndicator: FC<Props> = ({ device, orgId, measurement }) => {
  const [valueLabel, setValueLabel] = useState<string>("Rainfall (Last 24 Hours)");
  const { fetchData, data, isLoading } = useCurrentRainfallIndicator(device.id);

  useEffect(() => {
    if (measurement) {
      // Required
      const name = measurement.name;
      const fieldKey = measurement.fieldKey;

      // Optional
      const displayName = measurement.displayName;
      const fieldName = measurement.fieldName;
      const portNumber = parseInt(measurement.port ?? "0");
      const label = measurement.label;
      if (label) setValueLabel(label);

      const hasError = !name || !fieldKey;
      if (!hasError) {
        const getData = async () => {
          await fetchData({
            name,
            fieldKey,
            displayName,
            fieldName,
            portNumber,
            orgId,
          });
        };

        getData();
      }
    }
  }, [measurement, orgId]);

  const GetCurrentRainfallIndicator = useMemo(() => {
    return getIndicator(data, valueLabel, isLoading);
  }, [data, valueLabel, isLoading]);

  return <>{GetCurrentRainfallIndicator}</>;
};

export default CurrentRainfallIndicator;
